 import React, { useState } from 'react';
import { ChevronDown, Menu, X, CreditCard, Users, Shield, Zap, Clock, Eye, DollarSign, Send, CheckCircle } from 'lucide-react';
import Header from './header'
import Footer from './footer'
export default function UpiCard () {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [formData, setFormData] = useState({
    fullName: '',
    phoneNumber: '',
    email: '',
    companyName: '',
    message: ''
  });

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = () => {
    if (formData.fullName && formData.phoneNumber && formData.email) {
      alert('Form submitted! We will contact you soon.');
      setFormData({
        fullName: '',
        phoneNumber: '',
        email: '',
        companyName: '',
        message: ''
      });
    } else {
      alert('Please fill in all required fields.');
    }
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <Header />

      {/* Hero Section */}
      <section className="bg-gradient-to-br from-orange-50 to-pink-50 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
                Level Up your<br />
                Business Payments with<br />
                <span className="text-orange-500">@OMNI UPI</span>
              </h1>
              <p className="text-gray-600 mb-8 text-lg">
                Explore UPI For Your Business Payment Needs Like Petty Cash, Retail Expenses, Administrative Expenses And Lots More
              </p>
              <div className="space-y-4">
                <button className="bg-orange-500 text-white px-8 py-3 rounded-lg text-lg font-semibold hover:bg-orange-600 transition-colors">
                  Sign Up for UPI for Business
                </button>
                <div>
                  <button className="text-orange-500 hover:text-orange-600 font-semibold">
                    Book a Demo
                  </button>
                </div>
              </div>
            </div>
            <div className="relative">
              <div className="bg-white rounded-3xl p-8 shadow-lg transform rotate-3 hover:rotate-0 transition-transform">
                <div className="text-center">
                  <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <CreditCard className="w-8 h-8 text-orange-500" />
                  </div>
                  <h3 className="text-xl font-bold mb-2">Smart Payments</h3>
                  <p className="text-gray-600">Streamlined business transactions</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Icons Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-6 gap-8">
            {[
              { icon: Send, label: 'Retail Expenses' },
              { icon: CreditCard, label: 'Online Payments' },
              { icon: Users, label: 'Admin' },
              { icon: Users, label: 'Subscriptions' },
              { icon: DollarSign, label: 'Office Expenses' },
              { icon: CreditCard, label: 'Petty Cash' }
            ].map((item, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <item.icon className="w-8 h-8 text-orange-500" />
                </div>
                <p className="text-sm text-gray-600">{item.label}</p>
              </div>
            ))}
          </div>
          <div className="text-center mt-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Upgrade to @OMNI UPI for<br />
              seamless & efficient Business<br />
              Payments
            </h2>
            <p className="text-gray-600">
              Bring Onboard easy to use modes of payments for effortless spending
            </p>
          </div>
        </div>
      </section>

      {/* Two Column Features */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Truly Convenient Payments */}
            <div className="bg-gradient-to-br from-pink-100 to-orange-100 rounded-3xl p-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">
                Truly Convenient<br />Payments
              </h3>
              <ul className="space-y-3">
                <li className="flex items-center">
                  <CheckCircle className="w-5 h-5 text-green-500 mr-3" />
                  <span>Create UPI ID in 1 Click</span>
                </li>
                <li className="flex items-center">
                  <CheckCircle className="w-5 h-5 text-green-500 mr-3" />
                  <span>Send & Receive Payments</span>
                </li>
                <li className="flex items-center">
                  <CheckCircle className="w-5 h-5 text-green-500 mr-3" />
                  <span>UPI Powered Buddy Cards</span>
                </li>
                <li className="flex items-center">
                  <CheckCircle className="w-5 h-5 text-green-500 mr-3" />
                  <span>Easy to Use Mobile App</span>
                </li>
              </ul>
            </div>

            {/* Use UPI without Bank A/c */}
            <div className="bg-gradient-to-br from-blue-100 to-purple-100 rounded-3xl p-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">
                Use UPI without Bank A/c
              </h3>
              <ul className="space-y-3">
                <li className="flex items-center">
                  <CheckCircle className="w-5 h-5 text-green-500 mr-3" />
                  <span>Ensure Complete Security</span>
                </li>
                <li className="flex items-center">
                  <CheckCircle className="w-5 h-5 text-green-500 mr-3" />
                  <span>Separate Business & Personal Expenses</span>
                </li>
                <li className="flex items-center">
                  <CheckCircle className="w-5 h-5 text-green-500 mr-3" />
                  <span>Real Time Tracking</span>
                </li>
                <li className="flex items-center">
                  <CheckCircle className="w-5 h-5 text-green-500 mr-3" />
                  <span>Powerful Dashboard for 100% Visibility</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Lightning Fast Payments */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">
                Lightning-Fast Payments to<br />
                any UPI ID, Contact or QR Code
              </h2>
              <p className="text-gray-600 mb-6">
                Enjoy Super-Quick Payments like Never Before!
              </p>
            </div>
            <div className="relative">
              <div className="bg-gradient-to-br from-orange-100 to-pink-100 rounded-3xl p-8">
                <div className="w-24 h-24 bg-white rounded-full flex items-center justify-center mx-auto">
                  <Zap className="w-12 h-12 text-orange-500" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Three Benefits Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Begin a seamless one-click payment journey
            </h2>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white rounded-2xl p-8 text-center shadow-lg">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <Zap className="w-8 h-8 text-orange-500" />
              </div>
              <h3 className="text-xl font-bold mb-4">Get Started easily</h3>
              <p className="text-gray-600">
                With OmniCard, Integrating the power of one-click payment solutions is lightning-fast & smoother. Complete KYC and Onboard in Minutes
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 text-center shadow-lg">
              <div className="w-16 h-16 bg-pink-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <Clock className="w-8 h-8 text-pink-500" />
              </div>
              <h3 className="text-xl font-bold mb-4">Don't settle for Delays</h3>
              <p className="text-gray-600">
                Streamline your transactions with effortless UPI reconciliations and settlement. Enjoy a dependable payment journey with unparalleled convenience
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 text-center shadow-lg">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <Shield className="w-8 h-8 text-green-500" />
              </div>
              <h3 className="text-xl font-bold mb-4">Robust Security</h3>
              <p className="text-gray-600">
                OmniCard brings you Super Secure Payments, all without a bank account. Experience the key to safe and easy transactions. Enjoy a stress-free spending experience with OmniCard!
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">
                Turbocharge Your Business<br />
                Payments with UPI
              </h2>
              <div className="bg-gradient-to-br from-orange-100 to-pink-100 rounded-3xl p-8">
                <div className="w-24 h-24 bg-white rounded-2xl flex items-center justify-center mx-auto">
                  <CreditCard className="w-12 h-12 text-orange-500" />
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl shadow-xl p-8">
              <h3 className="text-xl font-bold text-center mb-6">Contact Us</h3>
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Your Full Name *
                  </label>
                  <input
                    type="text"
                    name="fullName"
                    value={formData.fullName}
                    onChange={handleInputChange}
                    placeholder="Enter Your Full Name"
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Phone Number *
                  </label>
                  <input
                    type="tel"
                    name="phoneNumber"
                    value={formData.phoneNumber}
                    onChange={handleInputChange}
                    placeholder="Enter Your Phone Number"
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Your Email *
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="Enter Your Email"
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Company Name
                  </label>
                  <input
                    type="text"
                    name="companyName"
                    value={formData.companyName}
                    onChange={handleInputChange}
                    placeholder="Enter Your Company Name"
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Your Message
                  </label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    placeholder="Enter Your Message"
                    rows={4}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                  />
                </div>

                <button
                  onClick={handleSubmit}
                  className="w-full bg-orange-500 text-white py-3 rounded-lg font-semibold hover:bg-orange-600 transition-colors"
                >
                  SUBMIT
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <Footer />
      {/* <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-5 gap-8">
            <div>
              <h4 className="font-bold mb-4">Products</h4>
              <ul className="space-y-2 text-sm text-gray-300">
                <li>Expense Management</li>
                <li>UPI for Business</li>
                <li>Corporate Cards</li>
                <li>Petty Cash Management</li>
                <li>Incentive Management</li>
                <li>Reimbursement</li>
                <li>Walletless</li>
                <li>Travels</li>
              </ul>
            </div>

            <div>
              <h4 className="font-bold mb-4">Assets</h4>
              <ul className="space-y-2 text-sm text-gray-300">
                <li>Blogs</li>
                <li>Case Studies</li>
                <li>Brand Guideline</li>
                <li>Testimonials</li>
                <li>Knowledge Hub</li>
                <li>eBooks</li>
                <li>Build a Complaint</li>
                <li>Report Fraud</li>
                <li>FAQs</li>
              </ul>
            </div>

            <div>
              <h4 className="font-bold mb-4">Policies</h4>
              <ul className="space-y-2 text-sm text-gray-300">
                <li>Privacy Policy</li>
                <li>Terms & Conditions</li>
                <li>Grievance Policy</li>
                <li>Refund Policy</li>
              </ul>
            </div>

            <div>
              <h4 className="font-bold mb-4">About Us</h4>
              <ul className="space-y-2 text-sm text-gray-300">
                <li>Our Story</li>
                <li>Media & Awards</li>
                <li>Career</li>
              </ul>
            </div>

            <div>
              <h4 className="font-bold mb-4">Brand owned by</h4>
              <div className="text-sm text-gray-300 mb-4">
                <div className="flex items-center space-x-2">
                  <span>⚡</span>
                  <span>Brand Technologies</span>
                </div>
                <p className="mt-2">The smarter way to manage</p>
              </div>
              
              <div className="space-y-2">
                <button className="text-orange-500 hover:text-orange-400">Book a Demo</button>
                <div className="text-sm text-gray-300">
                  An innovative company in<br />Bengaluru, India
                </div>
                <div className="text-sm text-gray-300">
                  Support queries:<br />support@omnicorp.com
                </div>
                <div className="text-sm text-gray-300">
                  Partner with us:<br />partnerships@omnicorp.com
                </div>
              </div>
            </div>
          </div>

          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-sm text-gray-400">
            <p>&copy; 2024 OmniCard. All rights reserved.</p>
          </div>
        </div>
      </footer> */}
    </div>
  );
};

// export default OmniCardLanding;